import CreateIcon from './CreateIcon';

export default CreateIcon;
